import React, { useEffect, useMemo } from 'react';

import BWAccordion from 'components/shared/BWAccordion';
import FormNumber from 'components/shared/BWFormControl/FormNumber';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { mapDataOptions4Select } from 'utils/helpers';
import { getOptionsGlobal } from 'actions/global';

import { ARRAY_DEFEND_CONDITION_COUPON_SETTING } from 'pages/Coupon/utils/helpers';
import styled from 'styled-components';
import { PortalIcon } from 'utils/baochauTheme';
import { formatIntegerInput, parseIntegerInput } from 'pages/Coupon/utils/numberFormat';

const SettingsWrapper = styled.div`
  .bw_coupon_settings_grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .bw_coupon_setting_card {
    padding: 14px;
    border: 1px solid #e4e7ec;
    border-radius: 12px;
    background: #fff;
    transition:
      border-color 0.18s ease,
      background-color 0.18s ease,
      box-shadow 0.18s ease;
  }

  .bw_coupon_setting_card.is-active {
    border-color: #f2aaa5;
    background: #fffafa;
    box-shadow: 0 0 0 3px rgba(237, 50, 55, 0.06);
  }

  .bw_coupon_setting_card.is-wide {
    grid-column: 1 / -1;
  }

  .bw_coupon_setting_toggle {
    position: relative;
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr) 42px;
    gap: 12px;
    align-items: center;
    cursor: pointer;
  }

  .bw_coupon_setting_toggle.is-disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  .bw_coupon_setting_toggle_input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .bw_coupon_setting_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #f2f4f7;
    color: #667085;
    font-size: 17px;
  }

  .bw_coupon_setting_card.is-active .bw_coupon_setting_icon {
    background: #fee4e2;
    color: #d92d32;
  }

  .bw_coupon_setting_title {
    display: block;
    margin-bottom: 2px;
    color: #101828;
    font-size: 14px;
    font-weight: 700;
  }

  .bw_coupon_setting_description {
    display: block;
    color: #667085;
    font-size: 12.5px;
    line-height: 18px;
  }

  .bw_coupon_switch {
    position: relative;
    width: 42px;
    height: 24px;
    border-radius: 999px;
    background: #d0d5dd;
    transition: background-color 0.18s ease;
  }

  .bw_coupon_switch::after {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.2);
    content: '';
    transition: transform 0.18s ease;
  }

  .bw_coupon_setting_card.is-active .bw_coupon_switch {
    background: #ed3237;
  }

  .bw_coupon_setting_card.is-active .bw_coupon_switch::after {
    transform: translateX(18px);
  }

  .bw_coupon_setting_content {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #eaecf0;
  }

  .bw_coupon_limit_fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 260px));
    gap: 12px;
  }

  @media (max-width: 900px) {
    .bw_coupon_settings_grid,
    .bw_coupon_limit_fields {
      grid-template-columns: 1fr;
    }
  }
`;

const CouponSetting = ({ disabled, title }) => {
  const dispatch = useDispatch();
  const methods = useFormContext({});
  const { watch, setValue } = methods;

  const { promotionsData, couponsData } = useSelector((state) => state.global);
  const currentCouponId = Number(watch('coupon_id')) || null;
  const couponOptions = useMemo(
    () =>
      mapDataOptions4Select(couponsData).filter(
        (couponOption) => !currentCouponId || Number(couponOption.value) !== currentCouponId,
      ),
    [couponsData, currentCouponId],
  );

  useEffect(() => {
    dispatch(
      getOptionsGlobal('promotions', {
        is_active: 1,
      }),
    );

    dispatch(
      getOptionsGlobal('coupons', {
        is_active: 1,
      }),
    );
  }, [dispatch]);

  const checkNumberBettween = (value, valFirst = null, valueSecond = null) => {
    let result = value;
    if (valFirst && value < valFirst) {
      result = valFirst;
    }

    if (valueSecond && valueSecond < valFirst) {
      result = valueSecond;
    }
    return result;
  };

  const handleAndCheckConditionConpon = (field, value, valueDefault = null) => {
    const cloneDefffendArray = structuredClone(ARRAY_DEFEND_CONDITION_COUPON_SETTING);
    const getKeyCloneDefffendArray = Object.keys(cloneDefffendArray);
    getKeyCloneDefffendArray?.forEach((val) => {
      if (val && val === field) {
        setValue(field, value);
      }
    });
    let resetArray = cloneDefffendArray[field];
    if (resetArray) {
      resetArray.forEach((val) => {
        if (val) {
          setValue(val, valueDefault);
          // if(!value) {
          //   methods.unregister(val, {});
          // } else {
          //   methods.register(val, { required: 'Trường bắt buộc' });
          // }
        }
      });
    }
  };

  return (
    <BWAccordion title={title}>
      <SettingsWrapper className='bw_frm_box'>
        <div className='bw_coupon_settings_grid'>
          <div className={`bw_coupon_setting_card ${watch('is_aplly_other_coupon') ? 'is-active' : ''}`}>
            <label className={`bw_coupon_setting_toggle ${disabled ? 'is-disabled' : ''}`}>
              <FormInput
                className='bw_coupon_setting_toggle_input'
                disabled={disabled}
                type='checkbox'
                field='is_aplly_other_coupon'
                onChange={(evt) => {
                  handleAndCheckConditionConpon('is_aplly_other_coupon', evt.target.checked, []);
                }}
              />
              <span className='bw_coupon_setting_icon'>
                <PortalIcon icon='fi fi-rr-layers' />
              </span>
              <span>
                <span className='bw_coupon_setting_title'>Kết hợp mã giảm giá khác</span>
                <span className='bw_coupon_setting_description'>
                  Chọn các mã được dùng cùng. Cả hai mã phải cho phép kết hợp với nhau.
                </span>
              </span>
              <span className='bw_coupon_switch' />
            </label>
            {Boolean(watch('is_aplly_other_coupon')) && (
              <div className='bw_coupon_setting_content'>
                <FormItem disabled={disabled} isRequired label='Mã được phép kết hợp'>
                  <FormSelect
                    list={couponOptions}
                    mode='multiple'
                    disabled={disabled}
                    placeholder='Chọn một hoặc nhiều mã giảm giá'
                    onChange={(value) => setValue('list_coupon_apply', value || [])}
                    field='list_coupon_apply'
                    validation={{
                      required: 'Vui lòng chọn ít nhất một mã giảm giá được phép kết hợp',
                    }}
                  />
                </FormItem>
              </div>
            )}
          </div>

          <div className={`bw_coupon_setting_card ${watch('is_aplly_other_promotion') ? 'is-active' : ''}`}>
            <label className={`bw_coupon_setting_toggle ${disabled ? 'is-disabled' : ''}`}>
              <FormInput
                className='bw_coupon_setting_toggle_input'
                disabled={disabled}
                type='checkbox'
                field='is_aplly_other_promotion'
                onChange={(evt) => {
                  handleAndCheckConditionConpon('is_aplly_other_promotion', evt.target.checked, []);
                }}
              />
              <span className='bw_coupon_setting_icon'>
                <PortalIcon icon='fi fi-rr-megaphone' />
              </span>
              <span>
                <span className='bw_coupon_setting_title'>Kết hợp chương trình khuyến mại</span>
                <span className='bw_coupon_setting_description'>Cho phép cộng dồn với các chương trình được chọn.</span>
              </span>
              <span className='bw_coupon_switch' />
            </label>
            {Boolean(watch('is_aplly_other_promotion')) && (
              <div className='bw_coupon_setting_content'>
                <FormItem disabled={disabled} label='Chương trình được phép kết hợp'>
                  <FormSelect
                    list={mapDataOptions4Select(promotionsData) ?? []}
                    mode='multiple'
                    disabled={disabled}
                    placeholder='Chọn một hoặc nhiều chương trình'
                    field='list_order_promotion_apply'
                    onChange={(value) => setValue('list_order_promotion_apply', value || [])}
                  />
                </FormItem>
              </div>
            )}
          </div>

          <div className={`bw_coupon_setting_card is-wide ${watch('is_limit_promotion_times') ? 'is-active' : ''}`}>
            <label className={`bw_coupon_setting_toggle ${disabled ? 'is-disabled' : ''}`}>
              <FormInput
                className='bw_coupon_setting_toggle_input'
                disabled={disabled}
                type='checkbox'
                field='is_limit_promotion_times'
                onChange={(evt) => {
                  handleAndCheckConditionConpon('is_limit_promotion_times', evt.target.checked, 1);
                }}
              />
              <span className='bw_coupon_setting_icon'>
                <PortalIcon icon='fi fi-rr-user-time' />
              </span>
              <span>
                <span className='bw_coupon_setting_title'>Giới hạn sử dụng theo khách hàng</span>
                <span className='bw_coupon_setting_description'>Kiểm soát số lần một khách hàng được dùng coupon.</span>
              </span>
              <span className='bw_coupon_switch' />
            </label>
            {Boolean(watch('is_limit_promotion_times')) && (
              <div className='bw_coupon_setting_content bw_coupon_limit_fields'>
                <FormItem disabled={disabled} label='Số lượt tối đa'>
                  <FormNumber
                    bordered
                    min={1}
                    precision={0}
                    formatter={formatIntegerInput}
                    parser={parseIntegerInput}
                    addonAfter='lần'
                    field='count_promotion_times'
                    disabled={disabled}
                    onChange={(value) => setValue('count_promotion_times', checkNumberBettween(value, 1))}
                  />
                </FormItem>

                {Number(watch('is_auto_gen')) === 0 && (
                  <FormItem disabled={disabled} label='Chu kỳ giới hạn'>
                    <FormNumber
                      bordered
                      min={1}
                      precision={0}
                      formatter={formatIntegerInput}
                      parser={parseIntegerInput}
                      addonAfter='tháng'
                      field='mounth_promotion_times'
                      disabled={disabled}
                      onChange={(value) => setValue('mounth_promotion_times', checkNumberBettween(value, 1))}
                    />
                  </FormItem>
                )}
              </div>
            )}
          </div>
        </div>
      </SettingsWrapper>
    </BWAccordion>
  );
};

export default CouponSetting;
